import React, { useContext } from "react";
import InvoiceList from "~/components/general/InvoiceList";
import Card from "~/components/parts/Card";
import { SubscriptionContext } from ".";

const Invoices = () => {
  const { invoices = [] } = useContext(SubscriptionContext);
  return (
    <Card className="border-l-0" title="Invoices">
      {invoices.length ? (
        <InvoiceList invoices={invoices} />
      ) : (
        <p className="m-0 text-sm text-gray-400">No invoices found</p>
      )}
    </Card>
  );
};

export default Invoices;
